import React from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import AdminSetup from "./AdminSetup";

const ProtectedAdminRoute: React.FC = () => {
  const { user, isAdmin, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return;
  }

  // If logged in but not admin, show admin setup
  if (!isAdmin) {
    return;
  }

  return <Outlet />;
};
export default ProtectedAdminRoute;
